import React from "react";
import { useState, useContext } from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import SessionContext from "SessionContext";
import DataTable from "../../core/ui/data-table";
import CreateNew from "./create-new";
import EditCurrent from "./edit-current";
import RoyaltyErrorModal from "./royalty-error-modal"

/**
 * This list is used to generate dynamic api query
 * if adding values, make sure they are valid admin/get queries
 */
export const editorsList = {
  source: "source",
  product: "product",
  subproduct: "subproduct"
}

function SourceEditor({handleChanges}) {
  const session = useContext(SessionContext);

  const [creatingNew, setCreatingNew] = useState(false);
  const [editingItems, setEditingItems] = useState(false);
  const [editingDetails, setEditingDetails] = useState(null);
  const [isSaveError, setIsSaveError] = useState(false);

  // UPDATE EXISTING
  const onUpdate = (updated) => {
    session
      .command(
        "admin/update_royalty_source",
        updated,
        {},
        { defaultErrorHandling: false }
      )
      .then(() => {
        handleCancel();
      })
      .catch((error) => {
        setIsSaveError(true);
      });
  };

  // CREATE NEW
  const onCreateNew = (newItem) => {
    if (newItem.name) {
      session
        .command(
          "admin/create_royalty_source",
          newItem,
          {},
          { defaultErrorHandling: false }
        )
        .then(() => {
          handleCancel();
        })
        .catch((error) => {
          setIsSaveError(true);
        });
    }
  };

  const onEditSubProduct = (subProduct) => {
    setEditingDetails(subProduct);
    setEditingItems(true);
  };

  const handleCancel = () => {
    handleChanges(false);
    setCreatingNew(false);
    setEditingItems(false);
    setEditingDetails(null);
  }

  // table functionality
  const table_columns = [
    { header: "Name", key: "name" },
    { header: "Description", key: "description" },
    { header: "Split By Client", key: "split_by_client", render: (value) => {
        if(value.split_by_client === true) {return "Yes"}
        else {return "No"}
      } 
    }
  ];

  const table_actions = (subproduct_to_edit) => (
    <React.Fragment>
      <button
        className="btn-table-edit"
        type="button"
        onClick={() => onEditSubProduct(subproduct_to_edit)}
      >
        <i className="bi bi-map-fill"></i> Edit
      </button>
    </React.Fragment>
  );

  const hideSaveError = () => {
    setIsSaveError(false);
  }

  return (
    <div className="modify-section">
      <h4>SOURCES</h4>

      <div className="section create-new-section">
        {creatingNew ? (
          <Card>
            <CardHeader>
              <strong>Create New Source:</strong>
            </CardHeader>
            <CardBody>
              <CreateNew onCancel={handleCancel} onCreate={onCreateNew} addSplitCheckbox handleChanges={handleChanges} />
            </CardBody>
          </Card>
        ) : (
          <>
            <button
              onClick={() => setCreatingNew(true)}
              disabled={editingItems}
            >
              Add New Source
            </button>
          </>
        )}
      </div>

      <div className="editing-section">
        {editingItems ? (
          <Card>
            <CardHeader>
              <strong>Edit Source:</strong>
            </CardHeader>
            <CardBody>
              <EditCurrent
                itemInfo={editingDetails}
                onCancel={handleCancel}
                onUpdate={onUpdate}
                addSplitCheckbox
                editingTitle={editorsList.source}
                handleChanges={handleChanges}
              />
            </CardBody>
          </Card>
        ) : (
          ""
        )}
      </div>

      <div className="listing-section">
        {editingItems === false && creatingNew === false ? (
          <div>
            <Card>
              <CardBody>
                <DataTable
                  query="admin/royalty_sources"
                  cols={table_columns}
                  actions={table_actions}
                  empty="No Sources Found"
                />
              </CardBody>
            </Card>
          </div>
        ) : (
          ""
        )}
      </div>
      <RoyaltyErrorModal
        isOpen={isSaveError}
        hideError={() => hideSaveError()}
        type="source"
      />
    </div>
  );
}

export default SourceEditor;
